import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, useField } from '@rocketseat/unform';

import {
  Modal,
  Text,
  Button,
  WrapperFlex,
  Title,
  Breadcrumbs,
} from '@unimed-fesp/components';

import { ImFloppyDisk } from 'react-icons/im';
import { isEqual } from 'lodash';
import produce from 'immer';

import theme from '../../styles/theme';

import {
  isValidMesmoTelefone,
  isValidMesmoCelular,
} from '../../utils/validation';

import { excludeData } from '../../services/auth';

import {
  TipoTelefoneEnum,
  PermissaoContratanteEnum,
  TipoStatusEnum,
  TipoPerfilUsuarioEnum,
} from '../../enums';

import history from '../../services/history';

import TabFormUsuario from '../../components/organisms/TabFormUsuario';
import ModalLiberarAcesso from '../../components/organisms/ModalLiberarAcesso';

import { Creators as UsuarioActions } from '../../store/ducks/usuario';
import { Creators as AuthActions } from '../../store/ducks/auth';

import { Container } from './styles';

import useParametrizacao from '../../hooks/useParametrizazao';

import ModalCancelActionFooter from './ModalCancelActionFooter';

function UsuarioDetalhe({ match }) {
  const { idUsuario } = match.params;

  const { idUsuarioLogado } = useSelector((state) => state.auth.usuario);
  const { parametrizacaoRoot } = useSelector((state) => state.contratante);
  const dispatch = useDispatch();

  const {
    getUsuarioById,
    getContatoById,
    getDadosAcessoById,
    getHistoricoMovimentacoes,
    patchLiberarAcesso,
    patchStatusUsuario,
    patchDadosGerais,
    patchDadosAcesso,
  } = useSelector((state) => state.usuario);

  const { salvarParametrizacao, hasAlteracao } = useParametrizacao(
    idUsuario,
    getUsuarioById.response.tipoPerfil
  );

  const editarUsuarioParam = {
    idUsuario: parseInt(idUsuario, 10),
    nome: getUsuarioById.response.nome || '',
    matricula: getUsuarioById.response.matricula || '',
    tipoPerfil: getUsuarioById.response.tipoPerfil || '',
    permissao:
      PermissaoContratanteEnum.returnPermissaoForTipoPerfilUsuario[
        getUsuarioById.response.tipoPerfil
      ] || '',
    roles: getUsuarioById.response.roles,
  };

  const editarContatosParams = {
    contatos: [
      {
        tipo: TipoTelefoneEnum.returnNameForName.Residencial,
        numero: '',
      },
    ],
  };

  const editarDadosAcessoParams = {
    idUsuario: parseInt(idUsuario, 10),
    nome: getDadosAcessoById.response.nome,
    email: getDadosAcessoById.response.email,
    tipoStatus: getDadosAcessoById.response.tipoStatus,
  };

  const paginationTabParams = {
    pageNumber: 1,
    pageSize: 10,
  };

  const [openModalCancelAction, setOpenModalCancelAction] = useState({
    isOpen: false,
    text: '',
    textHeader: '',
    onClick: (_) => _,
    onClickOk: (_) => _,
  });
  const [usuarioParams, setUsuarioParams] = useState(editarUsuarioParam);
  const [contatoParams, setContatoParams] = useState(editarContatosParams);
  const [dadosAcessoParams, setDadosAcessoParams] = useState(
    editarDadosAcessoParams
  );
  const [originalContatoParams, setOriginalContatoParams] = useState(
    editarContatosParams
  );
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [openModalAcaoUsuario, setOpenModalAcaoUsuario] = useState({
    success: false,
    acaoUsuario: '',
    message: '',
  });
  const [modalError, setModalError] = useState({
    error: false,
    message: '',
  });
  const [activeTab, setActiveTab] = useState('dadosGerais');
  const [paginationParams, setPaginationParams] = useState(paginationTabParams);
  const [openModalLiberarAcesso, setOpenModalLiberarAcesso] = useState(false);
  const [liberarAcesso, setLiberarAcesso] = useState(false);

  function IsStateChangeFromOriginal(prevState, newState) {
    return !isEqual(prevState, newState);
  }

  useEffect(() => {
    const params = {
      ...paginationParams,
    };
    dispatch(UsuarioActions.getUsuarioByIdRequest(idUsuario));
    dispatch(UsuarioActions.getContatoByIdRequest(idUsuario));
    dispatch(UsuarioActions.getDadosAcessoByIdRequest(idUsuario));
    dispatch(
      UsuarioActions.getHistoricoMovimentacoesRequest(idUsuario, params)
    );
  }, []);

  useEffect(() => {
    if (getUsuarioById.response) setUsuarioParams(editarUsuarioParam);
  }, [getUsuarioById.response]);

  useEffect(() => {
    if (getContatoById.response.length > 0) {
      const contatos = getContatoById.response.map((contato) => ({
        tipo: contato.tipoContato,
        numero: contato.nrDdd.toString().concat(contato.nrNumero),
      }));
      setOriginalContatoParams({ contatos });
      setContatoParams({ contatos });
    } else {
      setContatoParams(editarContatosParams);
    }
  }, [getContatoById.response]);

  useEffect(() => {
    if (getDadosAcessoById.response) {
      const newDadosAcessoParams = produce(dadosAcessoParams, (draft) => {
        draft.idUsuario = parseInt(idUsuario, 10);
        draft.nome = getDadosAcessoById.response.nome;
        draft.email = getDadosAcessoById.response.email;
        draft.tipoStatus = getDadosAcessoById.response.tipoStatus;

        return draft;
      });
      setDadosAcessoParams(newDadosAcessoParams);
    }
  }, [getDadosAcessoById.response]);

  function IsSubmitDadosGerais() {
    if (
      IsStateChangeFromOriginal(editarUsuarioParam, usuarioParams) &&
      !IsStateChangeFromOriginal(originalContatoParams, contatoParams)
    ) {
      return IsStateChangeFromOriginal(editarUsuarioParam, usuarioParams);
    }
    if (
      !IsStateChangeFromOriginal(editarUsuarioParam, usuarioParams) &&
      IsStateChangeFromOriginal(originalContatoParams, contatoParams) &&
      (contatoParams.contatos.every((c) => c.numero === '') ||
        contatoParams.contatos.every((c) => isValidContato(c.numero, c.tipo)))
    ) {
      return (
        IsStateChangeFromOriginal(originalContatoParams, contatoParams) &&
        (contatoParams.contatos.every((c) => c.numero === '') ||
          contatoParams.contatos.every((c) => isValidContato(c.numero, c.tipo)))
      );
    }
    if (
      IsStateChangeFromOriginal(editarUsuarioParam, usuarioParams) &&
      IsStateChangeFromOriginal(originalContatoParams, contatoParams) &&
      contatoParams.contatos.every((c) => isValidContato(c.numero, c.tipo))
    ) {
      return (
        IsStateChangeFromOriginal(editarUsuarioParam, usuarioParams) ||
        (IsStateChangeFromOriginal(originalContatoParams, contatoParams) &&
          contatoParams.contatos.every((c) => c.numero !== '') &&
          contatoParams.contatos.every((c) => isValidContato(c.numero, c.tipo)))
      );
    }
  }
  function IsSubmitDadosAcesso() {
    return IsStateChangeFromOriginal(
      editarDadosAcessoParams,
      dadosAcessoParams
    );
  }

  const setButtonDisabledForTab = useCallback(
    (tabActive) => {
      const tabs = {
        dadosGerais: IsSubmitDadosGerais,
        dadosAcesso: IsSubmitDadosAcesso,
        parametros: () => hasAlteracao,
        historicoMovimentacao: (_) => _,
      };

      return tabs[tabActive]();
    },
    [IsSubmitDadosAcesso, IsSubmitDadosGerais, hasAlteracao]
  );

  useEffect(() => {
    const isDisabledButtonInActiveTab = setButtonDisabledForTab(activeTab);

    setIsButtonDisabled(!isDisabledButtonInActiveTab);
  }, [
    activeTab,
    usuarioParams,
    contatoParams,
    dadosAcessoParams,
    parametrizacaoRoot,
    setButtonDisabledForTab,
  ]);

  function isValidContato(contato, tipo) {
    const validContato = {
      Residencial: isValidMesmoTelefone(contato),
      Celular: isValidMesmoCelular(contato),
    };

    return validContato[tipo];
  }

  function preparaDadosGerais(data) {
    const formUsuarioParams = {
      idUsuario: parseInt(idUsuario, 10),
      nome: data.nome,
      matricula: data.matricula ? data.matricula : '',
      tipoPerfil: TipoPerfilUsuarioEnum.returnNameForNameFormatted[data.perfil],
      permissao: data.permissao ? data.permissao : '',
    };

    const formContatoParams = {
      contatos: [],
    };
    if (contatoParams.contatos?.length > 0)
      formContatoParams.contatos = contatoParams.contatos.map((c) => ({
        numero: c.numero,
        tipo: c.tipo,
      }));

    return { formUsuarioParams, formContatoParams };
  }

  function bindPermissaoToPerfil(data) {
    return TipoPerfilUsuarioEnum.returnNameForNameFormatted[data.perfil] !==
      TipoPerfilUsuarioEnum.returnNameForName.Adm
      ? PermissaoContratanteEnum.returnTipoPerfilUsuarioForPermissao[
          data.permissao
        ]
      : TipoPerfilUsuarioEnum.returnNameForNameFormatted[data.perfil];
  }

  function dadosGeraisSubmit(data) {
    const { formUsuarioParams, formContatoParams } = preparaDadosGerais(data);
    if (
      IsStateChangeFromOriginal(formUsuarioParams, editarUsuarioParam) ||
      IsStateChangeFromOriginal(formContatoParams, originalContatoParams)
    ) {
      if (
        formContatoParams.contatos.every((c) => c.numero !== '') &&
        formContatoParams.contatos.every((c) =>
          isValidContato(c.numero, c.tipo)
        )
      ) {
        formContatoParams.contatos.map((c) => {
          c.ddd = c.numero.substring(0, 2);
          c.numero = c.numero.substring(2);
        });
      } else {
        formContatoParams.contatos = [];
      }

      formUsuarioParams.tipoPerfil = bindPermissaoToPerfil(data);
      dispatch(
        UsuarioActions.patchDadosGeraisRequest(
          formUsuarioParams,
          formContatoParams
        )
      );
    }

    // if (
    //     IsStateChangeFromOriginal(
    //         formContatoParams,
    //         editarContatosParams
    //     ) &&
    //     formContatoParams.contatos.every((c) => c.numero !== '') &&
    //     formContatoParams.contatos.every((c) =>
    //         isValidContato(c.numero, c.tipo)
    //     )
    // ) {
    //     formContatoParams.contatos.map((c) => {
    //         c.ddd = c.numero.substring(0, 2);
    //         c.numero = c.numero.substring(2);
    //     });

    //     dispatch(
    //         UsuarioActions.patchRegistrarContatoRequest(
    //             formContatoParams,
    //             idUsuario
    //         )
    //     );
    // }
  }

  function dadosAcessoSubmit(data) {
    if (idUsuarioLogado !== idUsuario) setOpenModalLiberarAcesso(true);
    else if (idUsuarioLogado === idUsuario) handleAlterarProprioEmail(false);

    const formDadosAcessoParams = {
      idUsuario: parseInt(idUsuario, 10),
      email: data.email,
    };

    // dispatch(UsuarioActions.patchDadosAcessoRequest(formDadosAcessoParams));
  }

  function handleSubmit(data) {
    switch (activeTab) {
      case 'dadosGerais':
        dadosGeraisSubmit(data);
        break;
      case 'dadosAcesso':
        dadosAcessoSubmit(data);
        break;
      case 'parametros':
        salvarParametrizacao();
        break;
      default:
    }
  }

  function setUsuarioActionToDispatch(action, params) {
    const actions = {
      PendenteLiberacao: UsuarioActions.patchLiberarAcessoRequest(params),
      Ativo: UsuarioActions.patchStatusRequest(
        params,
        TipoStatusEnum.returnNameForName.Inativo
      ),
      Inativo: UsuarioActions.patchStatusRequest(
        params,
        TipoStatusEnum.returnNameForName.Ativo
      ),
    };

    return actions[action];
  }

  function handleAcaoUsuarioById(idUsuario, tipoAcao) {
    const params = [
      {
        idUsuario,
      },
    ];
    const actionUsuario = setUsuarioActionToDispatch(tipoAcao, params);

    dispatch(actionUsuario);
  }

  function handleModalUsuarioAcao() {
    setOpenModalAcaoUsuario({
      success: false,
      message: 'solicitação de liberação enviada.',
    });

    if (patchLiberarAcesso.success) {
      dispatch(UsuarioActions.patchLiberarAcessoRenew());
      if (idUsuarioLogado === idUsuario) {
        dispatch(UsuarioActions.getDadosAcessoByIdRequest(idUsuario));
      }
    }
    if (patchStatusUsuario.success) dispatch(UsuarioActions.patchStatusRenew());
    if (patchDadosGerais.success) {
      dispatch(UsuarioActions.patchDadosGeraisRenew());
    }
    if (patchDadosAcesso.success) {
      dispatch(UsuarioActions.patchDadosAcessoRenew());
      if (idUsuarioLogado === idUsuario) signOut();
    }
  }

  function handleModalError() {
    setModalError({
      error: !modalError.error,
      message: 'erro ao salvar os dados gerais.',
    });

    if (patchDadosAcesso.isError)
      dispatch(UsuarioActions.patchDadosAcessoRenew());
    if (patchDadosGerais.isError)
      dispatch(UsuarioActions.patchDadosGeraisRenew());
  }

  function handleActiveTab(tab) {
    setActiveTab(tab);
  }

  const handleAlterarProprioEmail = (isOpen) => {
    const newCancelAction = produce(openModalCancelAction, (draft) => {
      draft.isOpen = !isOpen;
      draft.text =
        'Ao alterar seu email perderá a sessão atual e qualquer dado não salvo. Deseja continuar?';
      draft.textHeader = 'cancelar';
      draft.onClick = (open) => handleAlterarProprioEmail(open);
      draft.onClickOk = () => {
        handleAlterarProprioEmail(true);
        handlePatchDadosAcesso();
      };

      return draft;
    });
    setOpenModalCancelAction(newCancelAction);
  };

  function handleModalCancelAction(isOpen) {
    const newCancelAction = produce(openModalCancelAction, (draft) => {
      draft.isOpen = !isOpen;
      draft.text =
        'Ao cancelar a edição do usuário, você perderá os dados não salvos. Deseja continuar?';
      draft.textHeader = 'cancelar';
      draft.onClick = (open) => handleModalCancelAction(open);
      draft.onClickOk = handleCancelar;

      return draft;
    });
    setOpenModalCancelAction(newCancelAction);
  }

  function handleModalLiberarAcesso() {
    setOpenModalLiberarAcesso(!openModalLiberarAcesso);
  }

  function handleLiberarAcesso() {
    setOpenModalLiberarAcesso(false);
    setLiberarAcesso(true);

    const formDadosAcessoParams = {
      idUsuario: parseInt(idUsuario, 10),
      email: dadosAcessoParams.email,
    };

    dispatch(UsuarioActions.patchDadosAcessoRequest(formDadosAcessoParams));
  }

  const handlePatchDadosAcesso = () => {
    const formDadosAcessoParams = {
      idUsuario: parseInt(idUsuario, 10),
      email: dadosAcessoParams.email,
    };

    dispatch(UsuarioActions.patchDadosAcessoRequest(formDadosAcessoParams));
  };

  function handleNaoLiberarAcesso() {
    setOpenModalLiberarAcesso(false);
    setLiberarAcesso(false);

    const formDadosAcessoParams = {
      idUsuario: parseInt(idUsuario, 10),
      email: dadosAcessoParams.email,
    };

    dispatch(UsuarioActions.patchDadosAcessoRequest(formDadosAcessoParams));
  }

  function handleChangePage(paramsPgs) {
    const params = {
      ...paramsPgs,
    };

    dispatch(
      UsuarioActions.getHistoricoMovimentacoesRequest(idUsuario, params)
    );
  }

  function handlePageChangeKeyDown(e) {
    if (e.keyCode === 13) {
      const params = {
        ...paginationParams,
      };

      if (paginationParams.pageNumber !== '')
        dispatch(
          UsuarioActions.getHistoricoMovimentacoesRequest(idUsuario, params)
        );
    }
  }

  const handleCancelar = useCallback(() => {
    history.push(`/novo/gestao`);
  }, []);

  const signOut = () => {
    dispatch(AuthActions.signOut());
    excludeData('@movcad');
    history.push('/novo/login');
  };

  useEffect(() => {
    if (patchLiberarAcesso.success && liberarAcesso) {
      setOpenModalAcaoUsuario({
        success: true,
        message: 'alterações de dados realizada e liberação enviada.',
      });
    } else if (patchLiberarAcesso.success) {
      setOpenModalAcaoUsuario({
        success: !openModalAcaoUsuario.success,
        message: 'solicitação de liberação enviada.',
      });
    }
  }, [patchLiberarAcesso.success]);

  useEffect(() => {
    if (patchLiberarAcesso.isError)
      setOpenModalAcaoUsuario({
        error: !modalError.error,
        message: 'erro ao enviar solicitação de liberação.',
      });
  }, [patchLiberarAcesso.isError]);

  useEffect(() => {
    if (patchDadosGerais.isError)
      setModalError({
        error: !modalError.error,
        message: 'erro ao salvar os dados gerais.',
      });
  }, [patchDadosGerais.isError]);

  useEffect(() => {
    if (patchDadosGerais.success)
      setOpenModalAcaoUsuario({
        success: !openModalAcaoUsuario.success,
        message: 'alteração de dados gerais realizada.',
      });
  }, [patchDadosGerais.success]);

  useEffect(() => {
    if (patchDadosAcesso.isError)
      setModalError({
        error: !modalError.error,
        message:
          patchDadosAcesso.error[0] || 'erro ao salvar os dados de acesso.',
      });
  }, [patchDadosAcesso.isError]);
  // useEffect(() => {
  //   if (patchDadosAcesso.success)
  //     setOpenModalAcaoUsuario({
  //       success: !openModalAcaoUsuario.success,
  //       message: 'alteração de dados de acesso realizada.',
  //     });
  // }, [patchDadosAcesso.success]);

  useEffect(() => {
    if (patchDadosAcesso.success && liberarAcesso) {
      const paramsLiberarAcesso = [
        {
          idUsuario,
        },
      ];
      dispatch(UsuarioActions.patchLiberarAcessoRequest(paramsLiberarAcesso));
    } else if (patchDadosAcesso.success) {
      setOpenModalAcaoUsuario({
        success: !openModalAcaoUsuario.success,
        message: 'Usuário alterado com sucesso!',
      });
    }
    dispatch(UsuarioActions.getDadosAcessoByIdRequest(idUsuario));
  }, [patchDadosAcesso.success]);

  return (
    <Container>
      <Title
        text="gestão de usuários"
        color={theme.titleGray}
        fontSize={38}
        marginBottom={8}
      />
      <Breadcrumbs
        crumbs={[
          { path: 'novo' },
          { path: 'gestão', onNavigate: () => history.push('/novo/gestao') },
          {
            path: `${getUsuarioById.response.nome}`,
            onNavigate: () =>
              history.push(`/novo/gestao/detalhe-usuario/${idUsuario}`),
          },
        ]}
      />
      <Form onSubmit={handleSubmit}>
        <TabFormUsuario
          usuarioParams={usuarioParams}
          setUsuarioParams={setUsuarioParams}
          contatoParams={contatoParams}
          setContatoParams={setContatoParams}
          dadosAcessoParams={dadosAcessoParams}
          setDadosAcessoParams={setDadosAcessoParams}
          usuarioDadosGerais={getUsuarioById}
          usuarioDadosAcesso={getDadosAcessoById.response}
          usuarioHistoricoMovimentacao={getHistoricoMovimentacoes}
          handleAcaoUsuarioById={handleAcaoUsuarioById}
          handleActiveTab={handleActiveTab}
          setPaginationParams={setPaginationParams}
          paginationParams={paginationParams}
          handlePageChangeKeyDown={handlePageChangeKeyDown}
          idUsuario={idUsuario}
          useField={useField}
          handleChangePage={handleChangePage}
        />
        <WrapperFlex marginTop={30} justifySpaceBetween alignCenter>
          <Button
            tipo="tertiary"
            justifyCenter
            alignCenter
            type="button"
            font="16px unimed_slabregular"
            width={100}
            onClick={() =>
              handleModalCancelAction(openModalCancelAction.isOpen)
            }
          >
            cancelar
          </Button>
          <Button
            tipo="primary"
            paddingTop={1}
            paddingRight={1}
            paddingBottom={1}
            paddingLeft={1}
            justifySpaceAround
            alignCenter
            type="submit"
            disabled={isButtonDisabled}
            display={activeTab === 'historicoMovimentacao' ? 'none' : ''}
            font="16px unimed_slabregular"
            width={100}
          >
            <ImFloppyDisk />
            salvar
          </Button>
        </WrapperFlex>
      </Form>
      <ModalLiberarAcesso
        onClick={handleModalLiberarAcesso}
        naoLiberarAcesso={handleNaoLiberarAcesso}
        liberarAcesso={handleLiberarAcesso}
        isOpen={openModalLiberarAcesso}
        isEditar
      />
      <Modal
        tipo="warning"
        onClick={() => {
          openModalCancelAction.onClick(openModalCancelAction.isOpen);
        }}
        isOpen={openModalCancelAction.isOpen}
        footer={
          <ModalCancelActionFooter
            onClick={() => {
              openModalCancelAction.onClick(openModalCancelAction.isOpen);
            }}
            onClickOk={openModalCancelAction.onClickOk}
          />
        }
      >
        <Text
          center
          text={openModalCancelAction.text}
          font="300 14px work_sans"
          color={theme.titleGray}
        />
      </Modal>
      <Modal
        tipo="success"
        onClick={handleModalUsuarioAcao}
        isOpen={openModalAcaoUsuario.success}
        footer={
          <>
            <Button
              tipo="primary"
              marginBottom={30}
              display="block"
              width={100}
              font="16px unimed_slabregular"
              onClick={handleModalUsuarioAcao}
            >
              ok
            </Button>
          </>
        }
      >
        <Text
          center
          text={openModalAcaoUsuario.message}
          font="300 14px work_sans"
          color={theme.titleGray}
        />
      </Modal>
      <Modal
        tipo="error"
        onClick={handleModalError}
        isOpen={modalError.error}
        footer={
          <>
            <Button
              tipo="primary"
              marginBottom={30}
              display="block"
              background="#ED1651"
              border="#ED1651"
              type="button"
              width={100}
              font="16px unimed_slabregular"
              onClick={handleModalError}
            >
              ok
            </Button>
          </>
        }
      >
        <Text
          center
          text={modalError.message}
          font="300 14px work_sans"
          color={theme.titleGray}
        />
      </Modal>
    </Container>
  );
}

export default UsuarioDetalhe;
